import { RenderMetaTags as RenderMetaTagsBase, RenderMetaTagsProps } from '@actinc/dls/components/RenderMetaTags';
import Head from 'next/head';
import React from 'react';
import NAMES from '~/constants/NAMES';
const HeadWrapped = (children: React.ReactElement[]): React.ReactElement => <Head data-sentry-element="Head" data-sentry-component="HeadWrapped" data-sentry-source-file="index.tsx">{children}</Head>;
const MetaTags: React.FC<RenderMetaTagsProps> = ({
  title,
  ...otherProps
}: RenderMetaTagsProps): React.ReactElement<RenderMetaTagsProps> => <RenderMetaTagsBase title={title || NAMES.APP} Wrapper={HeadWrapped} {...otherProps} data-sentry-element="RenderMetaTagsBase" data-sentry-component="MetaTags" data-sentry-source-file="index.tsx" />;
export default MetaTags;